/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_NumberInputs */

const en_page_number = /** @type {(inputs: Page_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page Number`)
};

const es_page_number = /** @type {(inputs: Page_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de página`)
};

const fr_page_number = /** @type {(inputs: Page_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numéro de page`)
};

const de_page_number = /** @type {(inputs: Page_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seitenzahl`)
};

const ja_page_number = /** @type {(inputs: Page_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ページ番号`)
};

const zh_page_number = /** @type {(inputs: Page_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`页码`)
};

const ar_page_number = /** @type {(inputs: Page_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رقم الصفحة`)
};

const id_page_number = /** @type {(inputs: Page_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nomor Halaman`)
};

const it_page_number = /** @type {(inputs: Page_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero di pagina`)
};

const ru_page_number = /** @type {(inputs: Page_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Номер страницы`)
};

const pt_page_number = /** @type {(inputs: Page_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número da página`)
};

const ko_page_number = /** @type {(inputs: Page_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`페이지 번호`)
};

/**
* | output |
* | --- |
* | "Page Number" |
*
* @param {Page_NumberInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const page_number = /** @type {((inputs?: Page_NumberInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_NumberInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_page_number(inputs)
	if (locale === "es") return es_page_number(inputs)
	if (locale === "fr") return fr_page_number(inputs)
	if (locale === "de") return de_page_number(inputs)
	if (locale === "ja") return ja_page_number(inputs)
	if (locale === "zh") return zh_page_number(inputs)
	if (locale === "ar") return ar_page_number(inputs)
	if (locale === "id") return id_page_number(inputs)
	if (locale === "it") return it_page_number(inputs)
	if (locale === "ru") return ru_page_number(inputs)
	if (locale === "pt") return pt_page_number(inputs)
	return ko_page_number(inputs)
});